import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CONTENT_BOX_ANIMATIONS } from "../../../shared/animations/content-box-animations";

@Component({
    selector: "app-text-animation",
    templateUrl: "./text-animation.component.html",
    styleUrls: ["./text-animation.component.scss"],
    animations: CONTENT_BOX_ANIMATIONS,
    standalone: false
})
export class TextAnimationComponent {
  @Input() animationDirection;
  @Input() contentBlockId;
  @Input() basicTextContent;
  @Output() textBlur = new EventEmitter();
  @Output() textFocus = new EventEmitter();
  @Input() animationState = false;
  @Input() animationType;
  @Input() isContentEditable = true;


  textClick(e) {
    this.textFocus.emit(e);
  }

  textOnBlur(event) {
    this.textBlur.emit(event);
  }
}
